<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Complaint-Create",
  path: "create",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
